import React, { useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo from '../../images/logo_white.png';
import './PageHeader.css'

function PageHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    closeMenu();
    
    // Check if we're already on the landing page
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Navigate to landing page with hash
      navigate(`/#${sectionId}`);
    }
  };

  return (
    <nav className="pageheader-navbar">
      <div className="pageheader-nav-content">
        <div className="pageheader-logo" onClick={() => navigate('/')}>
          <Link to="/">
            <img src={logo} alt="TalentScope360 Logo" />
          </Link>
        </div>
        
        {/* Hamburger Menu Button */}
        <button 
          className={`pageheader-hamburger ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`pageheader-nav-links ${isMenuOpen ? 'nav-open' : ''}`}>
          <button onClick={() => scrollToSection('features')} className="pageheader-nav-link">
            Features
          </button>
          <Link to="/pricing" onClick={closeMenu} className="pageheader-nav-link">
            Pricing
          </Link>
          <Link to="/documentation" onClick={closeMenu} className="pageheader-nav-link">
            Documentation
          </Link>
        </div>
        
        <div className="pageheader-nav-buttons">
          <a href="/login" className="pageheader-btn-login">Login</a>
          <Link to="/sign-up" className="pageheader-btn-getstarted">Get Started</Link>
        </div>

        {/* Overlay for mobile menu */}
        {isMenuOpen && <div className="pageheader-nav-overlay" onClick={closeMenu}></div>}
      </div>
    </nav>
  )
}

export default PageHeader